import { uniqueID } from "../../../util";
import { Element, Mode, ModeWithoutReadOnly, Type } from "./Form";

export class BaseElement {
  type: Type;
  renderId: string;

  constructor(type: Type, renderId?: string) {
    this.type = type;
    this.renderId = renderId ?? uniqueID()+'';
  }

  render(mode: Mode, onElementChange: (element: Element) => void): JSX.Element {
    onElementChange;
    return <>{mode}</>
  }

  validateField(mode: Mode): boolean {
    mode;
    return true;
  }

  getForDB(mode: ModeWithoutReadOnly) {
    mode;
    return {
      type: this.type,
      renderId: this.renderId,
    }
  }
}